import { Outlet } from 'react-router-dom'

import TopNavbar from '../../components/TopNavbar';
import Uganda_classes from './uganda_classes.jsx'
import International_countries from '../international_countries.jsx';
const Uganda = () => {
  return (
   <>
<TopNavbar />
<International_countries />
<Uganda_classes />

    
                

<Outlet />


    
    </>
  )
}

export default Uganda;